import React, { useState, useEffect }   from 'react';
import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import { useStyles,drawerWidth } from "../../layout/styles";
import CrudTable from "../../crud/CrudTable"
import {tagService as service} from "../../../services"

const initFilter =  {
    name: "",
};


export default function Tag() {
  const [filter, setFilter] = React.useState(initFilter);
  const fieldstable = ["name"];
  const headersTable =  ["Nombre"];

  const createEstructureFilter =  [
       {
         type:"input",
         name: "name",
         label: "Nombre",
         col: 12
        },
    ];


  return (
      <CrudTable
            service={service}
            titlePage={"Etiquetas Blog"}
            titleButton={"Añadir etiqueta"}
            urledit={"/tag/"}
            urlnew={"/tag/new/"}
            filter={initFilter}
            fieldstable={fieldstable}
            headersTable={headersTable}
            estructureForm={createEstructureFilter}
        />
  
  );
}
